/**
 * Marcador de campo obligatorio.
 *
 * Fuente única del asterisco: los componentes de campo (InputField, DropdownField,
 * NumericField, PriceInputField, MultiSelectDropdownField) lo agregan cuando `required`
 * es true. Los formularios NO deben hardcodear el `*` en el label — así el marcador y la
 * validación (`required`) nunca pueden discrepar.
 */
export const withRequiredMark = (label: string, required?: boolean): string =>
  required ? `${label}*` : label;
